import React, { useState, useEffect, useRef } from 'react';
import './UserIntent.css';
import { POPUP } from 'utils/constants/popup';
import app from 'new-ui/app';

import { useTranslation } from 'utils/modifiedTranslation';
import { useAlert } from 'components/Alert';
import Form from 'new-ui/Components/Form';

import {
  PopupTitle, PopupContent, PopupButton,
} from 'new-ui/Components/Popup';
import PropTypes from 'prop-types';

import { USER_INTENT_TYPES } from 'new-ui/constants';

const setUserIntent = async (type, other = '') => {
  await app.updateUserConfiguration({
    userIntent: {
      other,
      type: type.toUpperCase(),
    },
  });
};

const UserIntent = ({ closePopup }) => {
  const { t } = useTranslation();
  const { showAlert, hideAlert } = useAlert();

  const [form, setForm] = useState(null);
  const [type, setType] = useState(null);
  const [showOther, setShowOther] = useState(null);

  const other = useRef(null);
  const _ = useRef(t);

  useEffect(() => {
    const userIntent = app.coniguration?.userConfiguration?.userIntent || {};
    const f = {
      inputs: {
        type: {
          type: 'radio',
          options: [
            {
              value: USER_INTENT_TYPES.TREATMENT,
              title: _.current('user_intent.treatment'),
            },
            {
              value: USER_INTENT_TYPES.RESEARCH,
              title: _.current('user_intent.research'),
            },
            {
              value: USER_INTENT_TYPES.EDUCATE,
              title: _.current('user_intent.educate'),
            },
            {
              value: USER_INTENT_TYPES.OTHER,
              title: _.current('user_intent.other'),
            },
          ],
        },
      },
      data: {
        type: userIntent.type,
        other: userIntent.other || '',
      },
    };
    setForm(f);
    other.current.value = f.data.other || '';
    if (f.data.type === USER_INTENT_TYPES.OTHER) setShowOther(true);
  }, [_]);

  const onChange = () => {
    setType(form.data.type);
    if (form.data.type === USER_INTENT_TYPES.OTHER) {
      setShowOther(true);
      setTimeout(() => {
        other.current.focus();
        other.current.scrollIntoView();
      }, 10);
    } else {
      setShowOther(false);
    }
  };

  const save = async () => {
    await setUserIntent(type, form.data.other);
    closePopup();

    showAlert({
      content: (
        <div>
          {t('user_intent.thanks')}
          {' '}
          <span
            className="edit-button"
            onClick={() => {
              hideAlert();
              app.openPopup(POPUP.MEDICAL_PROFILE);
            }}
          >
            {t('medical_profile.edit')}
          </span>
        </div>
      ),
    });
  };

  const onEdit = (e) => {
    form.data.other = e.target.value;
  };

  return (
    <div className="user-intent">
      <PopupTitle title={t('user_intent.title')} />
      <PopupContent>
        <div className="user-intent-title">
          {t('user_intent.description')}
        </div>
        {form && <Form form={form} onChange={onChange} />}
        <div hidden={!showOther}>
          <textarea ref={other} className="user-intent-other" onChange={onEdit} placeholder={t('user_intent.other_placeholder')} />
        </div>
      </PopupContent>
      {type && <PopupButton title={t('user_intent.save')} action={save} />}
    </div>
  );
};

UserIntent.propTypes = {
  closePopup: PropTypes.func.isRequired,
};

export default UserIntent;
